import React, { forwardRef, ReactNode, MouseEventHandler } from "react";
import PropTypes from "prop-types";

import { color } from "../../utils/styles";
import Icon from "../Icon";

import { StyledButton, StyledSpinner, Text } from "./Styles";

// const propTypes = {
//   className: PropTypes.string,
//   children: PropTypes.node,
//   variant: PropTypes.oneOf(['primary', 'success', 'danger', 'secondary', 'empty']),
//   icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
//   iconSize: PropTypes.number,
//   iconColor: PropTypes.string,
//   disabled: PropTypes.bool,
//   isWorking: PropTypes.bool,
//   onClick: PropTypes.func,
// };

type PropT = {
  className: string | undefined;
  children: ReactNode | undefined;
  variant: "primary" | "success" | "danger" | "secondary" | "empty";
  icon: ReactNode | string | undefined;
  iconSize: number;
  iconColor: string;
  disabled: boolean;
  isWorking: boolean;
  onClick: () => void;
  [x: string]: any;
};

const defaultProps = {
  className: undefined,
  children: undefined,
  variant: "secondary",
  icon: undefined,
  iconSize: 18,
  disabled: false,
  isWorking: false,
  onClick: () => {},
};

const Button = forwardRef(
  (
    {
      children,
      variant,
      icon,
      iconSize,
      iconColor,
      disabled,
      isWorking,
      onClick,
      ...buttonProps
    }: PropT,
    ref: any
  ) => {
    const handleClick = () => {
      if (!disabled && !isWorking) {
        onClick();
      }
    };

    return (
      <StyledButton
        {...buttonProps}
        onClick={handleClick}
        variant={variant}
        disabled={disabled || isWorking}
        // @ts-ignore

        isWorking={isWorking}
        iconOnly={!children}
        ref={ref}
      >
        {isWorking && <StyledSpinner size={26} color={getIconColor(variant)} />}

        {!isWorking && icon && typeof icon === "string" ? (
          <Icon
            type={icon}
            size={iconSize}
            color={iconColor !== undefined ? iconColor : getIconColor(variant)}
          />
        ) : (
          icon
        )}
        {children && <Text withPadding={isWorking || icon}>{children}</Text>}
      </StyledButton>
    );
  }
);

const getIconColor = (variant: string) =>
  ["secondary", "empty"].includes(variant) ? color.textDark : "#fff";

// Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export default Button;
